import React from "react";
import { useCategories } from "../../hooks/useCategories";
import { getImageBaseUrl } from "../../services/s3-utils";
import { getCategoryImage } from "../../services/image-utils/getCategoryImage";
import SvgClose from "../../icons/SvgClose";

function Step6({
  setCurrStep,
  currStep,
  finishReg,
  selectedCategories = [],
  setSelectedCategories,
  loading,
}) {
  const categories = useCategories();
  return (
    <>
      <div className="flex flex-wrap gap-4 gap-y-8 pb-[87px]">
        {categories.map((category, i) => (
          <div
            onClick={() => {
              selectedCategories?.includes(category._id)
                ? setSelectedCategories(
                    selectedCategories?.filter((n) => n !== category._id)
                  )
                : setSelectedCategories([...selectedCategories, category._id]);
            }}
            key={i}
            data-testid={`category_${i}`}
            className={`py-[7px] cursor-pointer px-4 rounded-[32px] flex items-center gap-2.5 ${
              selectedCategories?.includes(category._id)
                ? "bg-pri"
                : "bg-pri-tint-3"
            } `}
          >
            <div className="flex items-center gap-2">
              <img
                src={getCategoryImage(category.category)}
                className="w-4 h-4"
                alt=""
              />
              <p
                className={`mb-0 p-xs font-medium ${
                  selectedCategories?.includes(category._id)
                    ? "text-white"
                    : "text-main"
                }`}
              >
                {category.category}
              </p>
            </div>
            <SvgClose
              className={`${
                selectedCategories?.includes(category._id)
                  ? "text-white"
                  : "text-tint"
              }`}
            />
          </div>
        ))}
      </div>

      <div className="w-full justify-between flex mt-10 [@media(min-width:987px)]:mb-40 fixed bottom-0 left-0 bg-white [@media(min-width:987px)]:bg-transparent p-5 [@media(min-width:987px)]:p-0 border-neutral [@media(min-width:987px)]:border-0 border-y [@media(min-width:987px)]:relative z-10">
        <button
          onClick={() => setCurrStep(currStep - 1)}
          className="bg-pri-tint px-5 py-3 rounded-lg pri w-1/2 mr-2"
        >
          Previous
        </button>

        <button
          data-testid="next_button"
          onClick={finishReg}
          className="bg-pri px-5 py-3 rounded-lg text-white w-1/2 ml-2 flex items-center justify-center"
        >
          {loading ? (
            <img
              className="w-8"
              src={`${getImageBaseUrl}/assets/spinner.svg`}
              alt=""
            />
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </>
  );
}

export default Step6;
